<div class="autocomplete-icon-wrapper" *ngIf="type == INPUT_TYPES.EMAIL">
  <i *ngIf="icon" [ngClass]="icon + ' icon-left'"></i>
  <input
    pInputText
    type="email"
    class="email-input"
    [ngModel]="value"
    (ngModelChange)="valueChange.emit($event)"
    [placeholder]="placeholder"
    [readonly]="readOnly"
    autocomplete="email"
  />
</div>

<div *ngIf="type === INPUT_TYPES.TEXT" class="autocomplete-icon-wrapper txt-input-wrapper">
  <i *ngIf="icon" [ngClass]="icon + ' icon-left'"></i>
  <p-autoComplete [class.icon]="!icon" class="padding-left"
    [ngModel]="value"
    (ngModelChange)="valueChange.emit($event)"
    [suggestions]="[]"
    [placeholder]="placeholder || ('inputForm.textPlaceholder' | transloco)"
    [inputStyle]="{ paddingLeft: '2rem' }"
    [type]="'text'"
    [forceSelection]="false"
    [dropdown]="false"
    [minLength]="0"
  ></p-autoComplete>
</div>

@if (type === INPUT_TYPES.PLATE) {
  <div [ngClass]="icon ? 'autocomplete-icon-wrapper' : ''">
    @if (icon) {
      <i [ngClass]="icon + ' icon-left'"></i>
    }
    <input
      type="text"
      class="plate-input"
      pInputText
      [ngModel]="value"
      (ngModelChange)="onPlateChange($event)"
      (input)="onPlateInput($event)"
      (keydown)="onPlateKeyDown($event)"
      [placeholder]="placeholder || ('inputForm.textPlaceholder' | transloco)"
      style="text-transform:uppercase"
      autocomplete="off"
    />
  </div>
}

@if (type === INPUT_TYPES.ID_ENTITY) {
  <div class="autocomplete-icon-wrapper">
    @if (icon) {
      <i [ngClass]="icon + ' icon-left'"></i>
    }
    <app-input-id-entity [icon]="icon ?? null" [placeholder]="placeholder" (valueChange)="onInputChange($event)"></app-input-id-entity>
  </div>
}

<div *ngIf="type === INPUT_TYPES.NUMBER" class="number-input-wrapper">
  <i *ngIf="icon" [ngClass]="icon + ' icon-left'"></i>
  <p-inputnumber [ngModel]="value" mode="decimal" inputId="withoutgrouping" [useGrouping]="false"  placeholder="{{ placeholder || ('inputForm.numberPlaceholder' | transloco) }}" (ngModelChange)="valueChange.emit($event)" />
</div>

<div *ngIf="type === INPUT_TYPES.PHONE" class="phone-input-wrapper">
  <p-select 
    [options]="listCountries" 
    [ngModel]="selectedCountry" 
    placeholder="{{ 'inputForm.countryPlaceholder' | transloco }}"
    optionLabel="name"
    optionValue="code"
    [group]="false" 
    class="box"
    (ngModelChange)="saveCountryCode($event)"
    [disabled]="disabledPhoneCode"
  >
    <ng-template let-country pTemplate="item">
      <div class="flex items-center">
        <img [src]="'assets/flags/1x1/' + country.code + '.svg'" class="mr-2" style="width: 20px" />
        <span>+{{ country.dialCode }}</span>
      </div>
    </ng-template>
    <ng-template let-country pTemplate="selectedItem">
      <img *ngIf="country" [src]="'assets/flags/1x1/' + country.code + '.svg'" style="width: 20px" />
    </ng-template>
  </p-select>
  <p-inputmask 
    mask="999-9999999"
    [ngModel]="value"
    class="phone-input"
    (ngModelChange)="savePhoneValue($event)"
    placeholder="{{ placeholder || '123-4567890' }}"
  />
</div>

<div *ngIf="type === INPUT_TYPES.SELECT" class="select-input-wrapper">
  <p-select 
    #selectRef
    [options]="list" 
    [ngModel]="value" 
    [filter]="filterSelected"
    (ngModelChange)="onSelectChange($event)"
    (onShow)="onSelectShow()"
    placeholder="{{ placeholder || ('inputForm.selectPlaceholder' | transloco) }}"
    optionLabel="name"
    optionValue="value"
    class="select-input"
    appendTo="body"
  ></p-select>
</div>

<div *ngIf="type === INPUT_TYPES.MULTI_SELECT" class="select-input-wrapper">
  <p-multiSelect
    [options]="list"
    [ngModel]="valueObject"
    (ngModelChange)="onSelectChange($event)"
    placeholder="{{ placeholder || ('inputForm.multiSelectPlaceholder' | transloco) }}"
    optionLabel="name"
    optionValue="value"
    class="select-input"
    appendTo="body"
    [filter]="filterSelected"
    display="chip"
  ></p-multiSelect>
</div>

<div *ngIf="type === INPUT_TYPES.DATE_PICKER" class="date-picker-wrapper">
  <p-datepicker [ngModel]="valueObject" [showTime]="showTime" [hourFormat]="hourFormat" placeholder="{{ placeholder || ('inputForm.datePlaceholder' | transloco) }}" (ngModelChange)="onPickedDate($event)" appendTo="body"/>
</div>
<div *ngIf="type === INPUT_TYPES.DATE_PICKER_YEAR" class="date-picker-wrapper">
  <p-datepicker [ngModel]="valueObject" [showTime]="showTime" [hourFormat]="hourFormat" placeholder="{{ placeholder || ('inputForm.yearPlaceholder' | transloco) }}" (ngModelChange)="onPickedDate($event)" view="year" dateFormat="yy" appendTo="body"/>
</div>